export interface GetMarketKeyParams {
  storeId?: string;
  marketId?: string | number;
  StoreId?: string;
  MarketId?: string | number;
}

export const getMarketKey = (market: GetMarketKeyParams): string => {
  const storeId = market.storeId ?? market.StoreId ?? '';
  const marketId = market.marketId ?? market.MarketId ?? '';
  return `${storeId}_${marketId}`;
};
